<app-table [data]="toolsGrouped"
           [config]="tableConfig"
           [groupableColumns]="groupableColumns"
           [groupFilters]="groupFilters"
           [isLoading]="isLoading "
           [isFilterExpanded]="isFilterExpanded"
           [isMaterial]="false"
           [showGroupFilters]="true"
           [displayToggleFilters]="false"
           [displayToolsUsageLegend]="true"
           [hasPagination]="true"
           [hasTitle]="hasTitle"
           [showFilters]="showFilters"
           [headerBackgroundColor]="headerBackgroundColor"
           [rowExpand]="true"
           [allExpanded]="false"
           [notMyProblem]="true"
           title="{{'admin.toolsUsage.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (filterGroupChange)="onFilterGroupChange($event)"
           (openInNewPage)="onOpenToolDetailsInNewPage($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column header="{{'admin.toolsUsage.table.columns.line' | translate}}"
                      [showTree]="true"
                      field="lineId"
                      class="bg-success">
        <ng-template #body
                     let-record="record">
            <div>
                {{ record.lineName }}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.toolsUsage.table.columns.toolName' | translate}}"
                      filterPlaceholder="{{'admin.toolsUsage.table.filters.toolName' | translate}}"
                      filter="true"
                      field="toolName">
    </app-table-column>
    <app-table-column header="{{'admin.toolsUsage.table.columns.toolUid' | translate}}"
                      field="toolUid">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input [(ngModel)]="column.filterValue"
                       placeholder="{{'admin.toolsUsage.table.filters.toolUid' | translate}}"
                       (inputChange)="onToolUidChange(table, column, $event)"></app-input>
        </ng-template>
        <ng-template #body
                     let-record="record">
            <div [class.tool-set]="isToolSet(record)">
                {{ isToolSet(record) ? 'SET' : record.toolUid }}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.toolsUsage.table.columns.toolStatus' | translate}}"
                      field="toolStatus">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="toolStatusList"
                          valueField="id"
                          displayField="name"
                          emptyText="{{'admin.toolsUsage.table.filters.toolStatus' | translate}}"
                          (selectItem)="table.onFilterChange(column)">
            </app-dropdown>
        </ng-template>
        <ng-template #body
                     let-record="record">
            <div>
                <div [class.tool-set]="isToolSet(record)" materialize="tooltip" class="tooltipped"
                     data-position="bottom" data-delay="50"
                     [attr.data-tooltip]="isToolSet(record) ? 'SET' : record.toolStance || 'N/A'">
                    {{ isToolSet(record) ? 'SET' : record.toolStatus }}
                </div>
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.toolsUsage.table.columns.cleaning' | translate}}"
                      filterPlaceholder="{{'admin.toolsUsage.table.filters.cleaning' | translate}}"
                      sortable="true"
                      field="cleaningPercentage"
                      [withBackgroundColor]="true">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="cleaningColorList"
                          valueField="id"
                          [isDisabled]="isLoading"
                          displayField="name"
                          emptyText="{{'admin.toolsUsage.table.filters.cleaning' | translate}}"
                          (selectItem)="table.onFilterChange(column)">
            </app-dropdown>
        </ng-template>
        <ng-template #body let-record="record">
            <div class="centered"
                 [class.pointer]="canRenderPointer(record, 1)"
                 (click)="onClickOperation(record, 1)">{{
                    record.cleaningPercentage + "% " +
                    (record.closestCleaningRecurrenceName ? "(" + record.closestCleaningRecurrenceName + ")" : "")
                }}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.toolsUsage.table.columns.maintenance' | translate}}"
                      filterPlaceholder="{{'admin.toolsUsage.table.filters.maintenance' | translate}}"
                      sortable="true"
                      field="maintenancePercentage"
                      [withBackgroundColor]="true">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="maintenanceColorList"
                          valueField="id"
                          [isDisabled]="isLoading"
                          displayField="name"
                          emptyText="{{'admin.toolsUsage.table.filters.maintenance' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body let-record="record">
            <div class="centered"
                 [class.pointer]="canRenderPointer(record, 2)"
                 (click)="onClickOperation(record, 2)">{{
                    record.maintenancePercentage + "%" +
                    (record.closestMaintenanceRecurrenceName ? "(" + record.closestMaintenanceRecurrenceName + ")" : "")
                }}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.toolsUsage.table.columns.measurements' | translate}}"
                      filterPlaceholder="{{'admin.toolsUsage.table.filters.measurements' | translate}}"
                      sortable="true"
                      field="measurementsPercentage"
                      [withBackgroundColor]="true">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="measurementsColorList"
                          valueField="id"
                          [isDisabled]="isLoading"
                          displayField="name"
                          emptyText="{{'admin.toolsUsage.table.filters.measurements' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body let-record="record">
            <div class="centered"
                 [class.pointer]="canRenderPointer(record, 3)"
                 (click)="onClickOperation(record, 3)">{{
                    record.measurementsPercentage + "%" +
                    (record.closestMeasurementsRecurrenceName ? "(" + record.closestMeasurementsRecurrenceName + ")" : "")
                }}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column cls="action">
        <ng-template #body
                     let-record="record">
            <div (click)=onOpenTicket(record.ticketId) *ngIf="record.ticketId" class="ticket">
                <span>{{ record.ticketId }}</span>
                <i class="material-icons">open_in_new</i>
            </div>
        </ng-template>
    </app-table-column>
    <app-table-info-row>
        <ng-template #body
                     let-record="record">
            <app-revision-multi-info *ngIf="record?.revisionInfo" class="data" [info]="record?.revisionInfo"></app-revision-multi-info>
        </ng-template>
    </app-table-info-row>
</app-table>
